
import axios from "axios";
const Instance = axios.create({
  baseURL: "https://api.bimash.com.np/discord/", 
});

export default Instance;